// Schreiben-Assistent: wer darf pflegen (Vorlagen, Briefköpfe, Absender) – wie is_admin() in der Datenbank.
import { supabase } from '../supabase/client';

export async function istAdmin(): Promise<boolean> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return false;
  const { data } = await supabase.from('profiles').select('role').eq('id', user.id).maybeSingle();
  return ['admin', 'super admin', 'superadmin', 'master admin'].includes(((data?.role as string) || '').toLowerCase());
}
